import * as MethodNames from './MethodNames';
export const GLOBAL_NAME = 'hsCalling';